/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from "react";

export default function ContentLayoutAddNewAssets() {
  return (
    <div>
      <div>
        <h2 className="helpHeaderTitle">Add New Assets </h2>
        <div className="helpContentSection">
          {" "}
          <div className="imageRow mb-3">
            <div className="imageSection">
              {" "}
              <img
                alt=""
                src={require("../../assets/images/helpCenter/contentCenterImg1.png")}
              />
            </div>
            <div className="imageInfoSection">
              <div className="boldTitle">Upload New Content</div>
              <div>
                Within the Content Tab, select “Add Content” and drag and drop
                OR upload files from computer drive.
              </div>
            </div>
          </div>
          <div className="mb-3">
            <div className="boldTitle mt-2">Tag Content</div>
            <div>
              Add any relevant tags so assets can be filtered and analytics can
              be properly measured, through entering text into the tag field -
              either bulk to apply to all content set to be uploaded or next to
              the individual file.
            </div>
          </div>
          <div className="mb-3">
            <div className="boldTitle mt-2">Set Expiration</div>
            <div>
              Content can be set to expire on a certain date from the field on
              the right. This will remove it from Publish completely on that
              date.
            </div>
          </div>
          <img
            alt=""
            src={require("../../assets/images/helpCenter/contentCenterImg2.png")}
          />
        </div>
      </div>
    </div>
  );
}
